import React, { Component } from "react";
import logo from "../../images/logo.svg";
import {
  BANNER_MESSAGE_LOGIN,
  BANNER_MESSAGE_REGISTRATION,
  BANNER_TITLE_LOGIN,
  BANNER_TITLE_REGISTRATION
} from "../../utils/constants";

class LoginBanner extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="banner-image-container">
          <img src={logo} className="logo-image" alt="vodacom_logo" />
        </div>
        <div className="banner-message-container">
          <h1 className="banner-message-title">
            {this.props.loginJourneyFlag
              ? BANNER_TITLE_LOGIN
              : BANNER_TITLE_REGISTRATION}
          </h1>
          <p className="banner-message-subtitle">
            {this.props.loginJourneyFlag
              ? BANNER_MESSAGE_LOGIN
              : BANNER_MESSAGE_REGISTRATION}
          </p>
        </div>
      </React.Fragment>
    );
  }
}

export default LoginBanner;
